module.exports = __webpack_public_path__ + "static/media/sq_fedex.7e10c593.png";